import ToolsBrowser from './components/ToolsBrowser'

const app = new Vue({
    el: '#app',
    components: {
        ToolsBrowser
    }
})